
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Loader from "@/components/App/Loader.vue";
import _ from "lodash";
@Component({
  components: {
    Loader
  }
})
export default class ChangePassword extends Vue {
  @Prop() private oldPassword!: string;
  @Prop() private newPassword!: string;
  @Prop() private confirmPassword!: string;
  @Prop() private rules!: any;

  @Getter("httpStatusText") httpStatusText: any;

  loading = false;
  private isOldPasswordInvalid = true;
  private isNewPasswordInvalid = true;
  private isConfirmPasswordInvalid = true;

  private isOldPasswordRequired = false;
  private isNewPasswordRequired = false;
  private isConfirmPasswordRequired = false;

  private isError = false;
  private isServerError = false;
  private isSuccess = false;

  mounted() {
    this.rules = [
      { message: "One lowercase letter required.", regex: /[a-z]+/ },
      { message: "One uppercase letter required.", regex: /[A-Z]+/ },
      { message: "One number required.", regex: /[0-9]+/ },
      { message: "One special character required.", regex: /[@#$]+/ }
    ];
  }

  onOldPasswordBlur() {
    if (!this.requiredValidation(this.oldPassword)) {
      this.isOldPasswordRequired = false;
    }
  }
  onNewPasswordBlur() {
    if (!this.requiredValidation(this.newPassword)) {
      this.isNewPasswordRequired = false;
      this.isNewPasswordInvalid = this.passwordValidation(this.newPassword);
    }
  }
  onConfirmPasswordBlur() {
    if (!this.requiredValidation(this.confirmPassword)) {
      this.isConfirmPasswordRequired = false;
      if (this.newPassword === this.confirmPassword) {
        this.isConfirmPasswordInvalid = true;
      } else {
        this.isConfirmPasswordInvalid = false;
      }
    }
  }
  onUpdateClick() {
    this.loading = true;
    this.isOldPasswordRequired = this.requiredValidation(this.oldPassword);
    this.isNewPasswordRequired = this.requiredValidation(this.newPassword);
    this.isConfirmPasswordRequired = this.requiredValidation(
      this.confirmPassword
    );
    if (
      !this.isOldPasswordRequired &&
      !this.isNewPasswordRequired &&
      !this.isConfirmPasswordRequired &&
      this.passwordValidation(this.newPassword) &&
      this.passwordValidation(this.confirmPassword)
    ) {
      this.$store
        .dispatch("updatePassword", {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        })
        .then(() => {
          console.log("this.httpStatusText " + this.httpStatusText);
          if (this.httpStatusText === "OldPassword") {
            this.resetFields(true, false, false);
            this.oldPassword = "";
          } else if (this.httpStatusText === "success") {
            this.resetFields(false, true, false);
            this.oldPassword = "";
            this.newPassword = "";
            this.confirmPassword = "";
          } else {
            this.resetFields(true, false, true);
          }

          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  }

  onCancelClick() {
    location.href = "https://my.bluetooth.com";
  }
  requiredValidation(input: string) {
    if (input != null && input.replace(/\s/g, "").length > 0) {
      return false;
    }
    return true;
  }
  resetFields(
    paramError: boolean,
    paramSuccess: boolean,
    paramServerError: boolean
  ) {
    this.isError = paramError;
    this.isSuccess = paramSuccess;
    this.isServerError = paramServerError;

    this.isOldPasswordInvalid = true;
    this.isNewPasswordInvalid = true;
    this.isConfirmPasswordInvalid = true;

    this.isOldPasswordRequired = false;
    this.isNewPasswordRequired = false;
    this.isConfirmPasswordRequired = false;
  }
  passwordValidation(currPassword: string) {
    let pwCharTypes = 0;
    const errors = [];
    const regexWhiteSpace = /\s/;
    const regexBadChars = /[/:/]/;
    const regexMinMaxLength = /^.{7,50}$/;

    if (
      !regexMinMaxLength.test(currPassword) ||
      regexWhiteSpace.test(currPassword) ||
      regexBadChars.test(currPassword)
    ) {
      return false;
    }

    for (const condition of this.rules) {
      if (!condition.regex.test(currPassword)) {
        errors.push(condition.message);
      } else {
        pwCharTypes++;
      }
    }
    if (errors.length === 0 || pwCharTypes >= 3) {
      return true;
    } else {
      return false;
    }
  }
}
